var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexContainer, Typography } from '@rappi/rests-commons-front';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import FileUploaderInline from '../../../../../commons/file-uploader-inline/file-uploader-inline';
import { useGlobal } from '../../../../../context/global/global.context';
import { commercialProcessesService } from '../../../../../services/commercial-processes.service';
import { BottomBar } from '../../bottom-bar/bottom-bar';
const DocumentsContainer = styled.div `
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 1fr;
  justify-content: center;
  gap: 16px;
`;
export const Documents = ({ step, goNext, goBack, saveData, data, mode }) => {
    var _a, _b;
    const { t } = useTranslation();
    const { state } = useGlobal();
    const { country = 'CO' } = state;
    const { key: stepKey } = step;
    const [files, setFiles] = useState((_a = data.files) !== null && _a !== void 0 ? _a : {});
    const handleFileUpload = (file, key, useAIScrapper) => __awaiter(void 0, void 0, void 0, function* () {
        const { id, file_details, scraping_data } = yield commercialProcessesService.uploadDocument(file, key, country, useAIScrapper);
        setFiles((prev) => (Object.assign(Object.assign({}, prev), { [key]: {
                id,
                file_details,
                scraping_data: useAIScrapper ? scraping_data : undefined,
            } })));
    });
    const handleFileRemove = (key) => {
        setFiles((prev) => (Object.assign(Object.assign({}, prev), { [key]: null })));
    };
    const handleNext = () => {
        saveData({
            files,
        });
        goNext();
    };
    const isAllFilesUploaded = useMemo(() => {
        var _a;
        if (!((_a = step.files) === null || _a === void 0 ? void 0 : _a.length))
            return false;
        return step.files.every((file) => {
            const uploadedFile = files[file.key];
            return uploadedFile !== null && uploadedFile !== undefined;
        });
    }, [files, step.files]);
    return (_jsxs(FlexContainer, { direction: "column", gap: 24, children: [_jsx(Typography, { component: "headline", children: t(`commercialProcess.steps.${stepKey}.title`) }), _jsx(Typography, { component: "body", children: t(`commercialProcess.steps.${stepKey}.description`) }), _jsx(DocumentsContainer, { children: (_b = step.files) === null || _b === void 0 ? void 0 : _b.map((f) => {
                    var _a, _b;
                    return (_jsx(FileUploaderInline, { id: f.key, label: t(`commercialProcess.steps.${stepKey}.labels.${f.key}`, {
                            defaultValue: f.key,
                        }), rules: {
                            accept: f.formats.map((f) => `.${f}`),
                            maxSizeMB: f.max_size,
                        }, aiScrapper: f.ai_scrapper, file: (_b = (_a = files[f.key]) === null || _a === void 0 ? void 0 : _a.file_details.url) !== null && _b !== void 0 ? _b : undefined, onFileChange: (file) => __awaiter(void 0, void 0, void 0, function* () {
                            yield handleFileUpload(file, f.key, f.ai_scrapper);
                        }), onRemove: () => {
                            handleFileRemove(f.key);
                        }, disabled: mode === 'only-view' }, f.key));
                }) }), _jsx(BottomBar, { backButton: {
                    onClick: goBack,
                    text: t('back'),
                    variant: 'secondary',
                }, nextButton: {
                    onClick: handleNext,
                    text: t('next'),
                    variant: 'primary',
                    disabled: !isAllFilesUploaded && mode === 'new',
                } })] }));
};
